import { useEffect, useRef } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { AddNetworkFormData } from '../form-validation';

type UseTrunkToggleValidationParams = {
  watch: UseFormMethods<AddNetworkFormData>['watch'];
  trigger: UseFormMethods<AddNetworkFormData>['trigger'];
};

export const useTrunkToggleValidation = ({
  watch,
  trigger,
}: UseTrunkToggleValidationParams): boolean => {
  const watchTrunked = watch('trunked');
  const isTrunked = watchTrunked === true;
  const previousTrunkedValueRef = useRef(watchTrunked);

  useEffect(() => {
    if (previousTrunkedValueRef.current !== watchTrunked) {
      trigger(['trunkedNetworks', 'network']);
    }

    previousTrunkedValueRef.current = watchTrunked;
  }, [watchTrunked, trigger]);

  return isTrunked;
};
